import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { LeaveKpiResponse } from "@/actions/ssr/leave/getLeaveKpiSSR";

const initialState: LeaveKpiResponse = {
  pending_request: { value: 0, label: "" },
  approved: { value: 0 },
  on_leave_today: { value: 0, label: "" },
  rejected: { value: 0 },
};

const leaveKpiSlice = createSlice({
  name: "leaveKpi",
  initialState,
  reducers: {
    setLeaveKpi(_state, action: PayloadAction<LeaveKpiResponse>) {
      return action.payload;
    },
  },
});

export const { setLeaveKpi } = leaveKpiSlice.actions;
export default leaveKpiSlice.reducer;
